import classes from "./styles.module.scss";
import clsx from "classnames";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import ArrowRight from "@/assets/ArrowRight.svg";
import Image from "@/ui/Image";
import { getGlobal } from "@/functions/getGlobal";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import { stripTags } from "@/functions/stripTags";

export const CtaCard = ({ className, title, text, url }) => {
  const global = getGlobal();
  const link = stripTags(global[url.path]).trim();
  return (
    <>
    {/* START: CMS Tools editable fix */}
    <SourceFlowText
      global={global}
      path={url.path}
      type="text"
      className="visually-hidden"
    >
      {url.placeholder}
    </SourceFlowText>
    {/* END: CMS Tools editable fix */}
    <a
      className={clsx(className, classes.cta, "text-overlay")}
      href={link}
      target={link.startsWith("http") ? "_blank" : "_self"}
      >
      <Image
        className="text-overlay__background"
        img={{ path: "component.cta.bg", src: "/assets/cta/default.png" }}
        size="626x220"
        alt=""
        />
      <div className="text-overlay__content">
        <i>
          <ArrowRight />
        </i>
        <div className={clsx(classes.cta__content, "p-4 pe-5 me-5")}>
          <DynamicText path={title.path} tag="h3" className="h5" />
          <DynamicHtml path={text.path} />
        </div>
      </div>
    </a>
    </>
  );
};
